var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.cls },
    [
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.listQuery.page,
          "page-sizes": [10, 20, 30, 50],
          "page-size": _vm.listQuery.limit,
          total: _vm.total,
          background: "",
          layout: _vm.layout,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }